/**
 * Herencia «de pantalla» de la ficha del producto de proveedor asociado
 * (productos.producto_proveedor_id). Si el producto no tiene foto propia o
 * descripción comercial propia, la interfaz enseña las del proveedor marcadas
 * como tales, para no verlo vacío. No se copia nada: para el sistema (checks de
 * documentación, Icecat, scraping) la ficha sigue vacía y se rellena como
 * siempre. En cuanto el producto tiene la suya, la heredada deja de verse.
 */

export const ETIQUETA_FOTO_PROVEEDOR = 'Foto Proveedor';
export const MARCA_FICHA_PROVEEDOR = '***** ficha de proveedor *****';

function conTexto(s: string | null | undefined): string | null {
  const t = s?.trim();
  return t ? t : null;
}

/**
 * Texto que se hereda para la descripción: la descripción del producto de
 * proveedor y, si no tiene, sus specs principales. Null si el producto ya tiene
 * descripción propia o el proveedor no aporta nada.
 */
export function descripcionHeredada(
  propia: string | null | undefined,
  proveedor: { descripcion: string | null; main_specs: string | null } | null,
): string | null {
  if (conTexto(propia) || !proveedor) return null;
  return conTexto(proveedor.descripcion) ?? conTexto(proveedor.main_specs);
}
